export const minus = (
  <svg
    width="16"
    height="2"
    viewBox="0 0 16 2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.8571 2H1.14286C0.839753 2 0.549063 1.89464 0.334735 1.70711C0.120408 1.51957 0 1.26522 0 1C0 0.734784 0.120408 0.48043 0.334735 0.292893C0.549063 0.105357 0.839753 0 1.14286 0H14.8571C15.1602 0 15.4509 0.105357 15.6653 0.292893C15.8796 0.48043 16 0.734784 16 1C16 1.26522 15.8796 1.51957 15.6653 1.70711C15.4509 1.89464 15.1602 2 14.8571 2Z" />
  </svg>
);
